import { ToastrService } from 'ngx-toastr';
import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { Router } from '@angular/router';
import { UserManagementService } from 'src/app/Service/user-management.service';
import { ManageSubProductComponent } from '../manage-sub-product/manage-sub-product.component';
import { DeleteProductComponent } from './delete-product/delete-product.component';

@Component({
  selector: 'app-manage-product',
  templateUrl: './manage-product.component.html',
  styleUrls: ['./manage-product.component.scss'],
})
export class ManageProductComponent implements OnInit {
  productForm: FormGroup;
  cropId: any;
  getProductList: [];
  selectedItems: any = [];

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private userService: UserManagementService,
    private toastr: ToastrService,
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<ManageProductComponent>
  ) {}

  ngOnInit(): void {
    this.formInIt();
    this.cropId = sessionStorage.getItem('marketCropId');
    this.getProductdata();
  }

  formInIt() {
    this.productForm = this.fb.group({
      productName: ['', [Validators.required, Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/)]],
    });
  }

  getProductdata() {
    this.userService.getProductlist(this.cropId).subscribe((res: any) => {
      this.getProductList = res.result.data;
    });
  }

  onSubmit() {
    let body = {
      cropId: this.cropId,
      productName: this.productForm.value.productName,
    };
    if(this.productForm.valid){
      this.userService.addMarketProduct(body).subscribe(
        (res: any) => {
          res.result.data == 1
            ? this.toastr.success(res.result.message)
            : this.toastr.error(res.result.message);
          this.getProductdata();
          this.productForm.reset();
        },
        (err) => {}
      );
    }else{
      this.toastr.error("Please fill the product name")
    }
  }

  deleteProduct() {
    if (this.selectedItems?.length > 0) {
      const dialogRef = this.dialog.open(DeleteProductComponent, {
        width: '35%',
        height: '36%',
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result.result === 'Yes') {
          const selectedArr = this.selectedItems.map((ele) => {
            return { productTypeID: ele, remark: result.remark };
          });
          const deleteBody = {
            removeProductType: selectedArr,
          };
          this.userService.deleteProduct(deleteBody).subscribe((data) => {
            if (data['result'].data == 1) {
              const arrayData = this.getProductList.filter(
                (obj: any) => !this.selectedItems.includes(obj.productTypeCode)
              );
              this.getProductList = arrayData as any;
              // this.getProductdata();
              this.toastr.success(data['result'].message, 'Success', {
                timeOut: 3000,
              });
              this.selectedItems = [];
            }
          });
        }
      });
    } else {
      this.toastr.warning('Please select any one product!', 'Info', {
        timeOut: 3000,
      });
    }
  }

  itemToDelete(id, event: any) {
    if (event.checked) {
      this.selectedItems.push(id);
    } else {
      const idArray = this.selectedItems.indexOf(id);
      this.selectedItems.splice(idArray, 1);
    }
  }

  closeModal() {
    this.dialogRef.close();
    this.router.navigate(['/MarketPlace']);
  }
}
